import Axios from 'axios';
import { RadioGroup } from 'devextreme-react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import Cookies from 'js-cookie';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bounce, toast } from 'react-toastify';
import { Button, Card, CardBody, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label, Row } from 'reactstrap';
import * as XLSX from 'xlsx';
import { useAuth } from '../../../auth';
import { goRiceUrl } from '../../../constant/siteConstants';
import useFormatMessage from '../../../utils/useFormatMessage';
import Breadcrumb from '../breadcrumb';
const ExcelUpload = ({ requiredColumnsSase, process_type, ExcelName, Title, depo, exampleData,
    role_name
}) => {
    const { t } = useFormatMessage();
    const [isLoading, setIsLoading] = useState(false);

    const { hasRole } = useAuth(15);


    const notifySuccess = (message) => toast.success(`${message}`, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        style: {
            fontSize: '15px',
            fontWeight: '600',
            borderRadius: '12px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
            border: '2px solid #4CAF50'
        }
    });

    const notifyError = (message) => toast.error(`${message}`, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        style: {
            fontSize: '15px',
            fontWeight: '600',
            borderRadius: '12px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
            border: '2px solid #f44336'
        }
    });

    const notifyWarning = (message) => toast.warn(`${message}`, {
        position: "top-right",
        autoClose: 7000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        style: {
            fontSize: '15px',
            fontWeight: '600',
            borderRadius: '12px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
            border: '2px solid #ff9800'
        }
    });

    const [file, setFile] = useState(null);
    const [error, setError] = useState('');
    const fileInputRef = useRef(null);
    const [errorArray, setErrorArray] = useState([]);
    const [successCount, setSuccessCount] = useState(0);
    // const [warningArray, setWarningArray] = useState([]);
    const [warningsArray, setWarningsArray] = useState([]);

    const errorGridRef = useRef(null);
    const warningGridRef = useRef(null);
    const warningsGridRef = useRef(null);

    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            try {
                const result = await processExcelWithDateTime(selectedFile);

                console.log('İşlenmiş veri:', result.data);
                console.log('Tarih kolonları:', result.dateColumns);

                setFile(selectedFile);
                setError('');

                // Eğer tarih kolonları varsa kullanıcıya bilgi ver
                // if (result.dateColumns.length > 0) {
                //   notifySuccess(`${result.dateColumns.length} tarih kolonu bulundu ve saat bilgisi ile işlendi: ${result.dateColumns.join(', ')}`);
                //}

            } catch (error) {
                const errorMessage = `
                    <div style="text-align: center; color: red; font-weight: bold;">
                        ⚠️ Excel dosyası okunurken bir hata oluştu!
                    </div>`;
                setError(errorMessage);
                notifyError("Excel dosyası okunurken bir hata oluştu!");
                setFile(null);
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
        }
    };

    const validateFileColumns = async (file) => {
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
            reader.onload = (event) => {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];

                let requiredCols = [...requiredColumnsSase];
                if (process_type === "VEHICLE") {
                    requiredCols = requiredCols.filter(col => col !== "warning" && col !== "warning_date");
                }

                const missingColumns = requiredCols.filter(col => !headers.includes(col));
                const allowedColumns = process_type === "VEHICLE"
                    ? [...requiredCols, "warning", "warning_date"]
                    : requiredCols;

                const extraColumns = headers.filter(col => !allowedColumns.includes(col));

                if (missingColumns.length || extraColumns.length) {
                    const missingColumnsFormatted = missingColumns.map(col => `<span style="color: red;">${col}</span>`).join(", ") || "Yok";
                    const extraColumnsFormatted = extraColumns.map(col => `<span style="color: red;">${col}</span>`).join(", ") || "Yok";

                    setError(`Eksik kolonlar: ${missingColumnsFormatted} <br/> Yüklenen dosya yanlış kolonlar: ${extraColumnsFormatted}`);
                    resolve(false);
                } else {
                    resolve(true);
                }
            };
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(file);
        });
    };

    const handleSubmit = async () => {
        setIsLoading(true); // Start loading
        document.getElementById("submit-button").disabled = true;

        if (depo) {
            if (document.querySelector("#depo-select-box").childNodes[0].childNodes[0].value === "") {
                notifyError(t("Lütfen bir depo seçiniz."));
                document.getElementById("submit-button").disabled = false;
                setIsLoading(false); // Stop loading
                return;
            }
        }

        if (!file) {
            notifyError(t("Lütfen önce bir Excel dosyası yükleyin."));
            document.getElementById("submit-button").disabled = false;
            setIsLoading(false); // Stop loading
            return;
        }

        const isValid = await validateFileColumns(file);
        if (!isValid) {
            document.getElementById("submit-button").disabled = false;
            setIsLoading(false); // Stop loading
            return;
        }

        const formData = new FormData();
        let warehouseCode;

        if (depo) {
            warehouseCode = document.getElementById('depo-select-box')
                .childNodes[0]
                .childNodes[0]
                .value;
            formData.append('warehouse_code', warehouseCode);
        }
        else if (process_type === "VEHICLE") {
            const isMilli = document.getElementById('isMilli')
                .childNodes[0]
                .value === "false";
            warehouseCode = isMilli ? "D000001" : "D000002";
            formData.append('warehouse_code', warehouseCode);
        }
        else {
            formData.append('warehouse_code', "");
        }

        // İşlenmiş dosyayı oluştur ve backend'e gönder
        try {
            const result = await processExcelWithDateTime(file);

            // İşlenmiş veriyi yeni bir Excel dosyasına yaz
            const processedWorkbook = XLSX.utils.book_new();
            const processedWorksheet = XLSX.utils.json_to_sheet(result.data);
            XLSX.utils.book_append_sheet(processedWorkbook, processedWorksheet, 'İşlenmiş Veri');

            // İşlenmiş dosyayı array olarak oluştur, sonra Blob'a çevir
            const processedFileArray = XLSX.write(processedWorkbook, { bookType: 'xlsx', type: 'array' });
            const processedFileBlob = new Blob([processedFileArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            // Blob'u File nesnesine çevir
            const processedFile = new File([processedFileBlob], file.name, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            formData.append('file', processedFile);
        } catch (error) {
            console.error('Dosya işleme hatası:', error);
            notifyError(t("Dosya işlenirken bir hata oluştu."));
            document.getElementById("submit-button").disabled = false;
            setIsLoading(false);
            return;
        }
        formData.append('process_type', process_type);
        formData.append('user_id', parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')));

        if (process_type === "VEHICLE") {
            formData.append('creator', document.getElementById("isMilli").childNodes[0].value);
            formData.append('type', document.getElementById('isMilli').childNodes[0].value === "GEMİ" ? "ithal" : "milli");
        }

        let headers = {
            'Content-Type': 'multipart/form-data',
            token: Cookies.get('token')
        };
        let BASE_API = process_type === "PDI_EXIT_CANCEL" ? `/api/updatePdiOrder` : `/api/vehicle/add`
        try {
            const response = await Axios.post(`${goRiceUrl}${BASE_API}`, formData, { headers });

            if (response.data.success) {
                let errorArray = [];
                let warningsArray = [];
                let successCount = response.data.stats.created + response.data.stats.updated;
                let failedCount = response.data.stats.failed;

                // Process results and convert warning strings to array
                response.data.results.forEach((result) => {
                    if (result.error) {
                        errorArray.push({
                            chassis_no: result.chassis_no,
                            message: t(result.error) || t("Bilinmeyen hata"),
                            action: result.action || "validation_failed"
                        });
                    }

                    if (result.warnings) {
                        warningsArray.push({
                            chassis_no: result.chassis_no,
                            message: result.warnings?.join(" 🔷 ")?.replaceAll("not found for brand", "seçili marka için bulunamadı: ").replaceAll("Brand", "Marka").replaceAll("not found in system", " sistemde tanımlı değil").replaceAll("color", "Renk"),
                            action: "warning"
                        })
                    }

                    if (result.warning) {
                        if (result.warning.info && result.warning.date) return
                        warningsArray.push({
                            chassis_no: result.chassis_no,
                            message: result.warning,
                            action: "warning"
                        });
                    }
                });

                setErrorArray(errorArray);
                setSuccessCount(successCount);
                setWarningsArray(warningsArray);

                // Daha detaylı ve kullanıcı dostu mesajlar
                let message = '';
                let hasSuccess = successCount > 0;
                let hasErrors = failedCount > 0;
                let hasWarnings = warningsArray.length > 0;

                if (hasSuccess) {
                    message += `✅ ${successCount} adet başarılı`;
                }
                if (hasErrors) {
                    message += hasSuccess ? ` | ❌ ${failedCount} adet hatalı` : `❌ ${failedCount} adet hatalı`;
                }
                if (hasWarnings) {
                    message += (hasSuccess || hasErrors) ? ` | ⚠️ ${warningsArray.length} adet uyarılı` : `⚠️ ${warningsArray.length} adet uyarılı`;
                }
                message += ' kayıt';

                // Toast mesajlarını iyileştir
                if (!hasErrors && !hasWarnings) {
                    notifySuccess(`${successCount} adet kayıt başarıyla işlendi!`);
                } else if (hasErrors && !hasWarnings) {
                    notifyError(`❌ ${message} - Lütfen hataları kontrol ediniz.`);
                } else if (hasWarnings && !hasErrors) {
                    notifyWarning(`⚠️ ${message} - Uyarıları kontrol ediniz.`);
                } else {
                    notifyWarning(`📊 ${message} - Hata ve uyarıları kontrol ediniz.`);
                }
            } else {
                notifyError(t("İşlem başarısız oldu."));
            }
        } catch (error) {
            let errorMessage = error.response?.data?.error?.replace("file processing error: failed to transform data:", "") || t("Dosya yüklenirken bir servis hatası oluştu.");

            // Hata mesajını parçala ve formatla
            if (errorMessage && errorMessage.includes(":")) {
                const parts = errorMessage.split(":");
                if (parts.length >= 2) {
                    const firstPart = parts[0].trim(); // İlk kısım (örn: "row 3: VXKUPHNS6R425062")
                    const remainingParts = parts.slice(1).join(":").trim(); // Kalan kısımlar

                    errorMessage = `${firstPart}: ${t(remainingParts)}`;
                }
            }

            console.error('Error uploading file:', error);
            notifyError(`❌ ${t("Dosya yüklenirken bir servis hatası oluştu.")} ${errorMessage}`);
            setErrorArray([{
                chassis_no: "GENEL HATA",
                message: errorMessage?.replace("dosya işlenirken hata:", "") || t("Dosya yüklenirken bir servis hatası oluştu."),
                action: "system_error"
            }]);
        } finally {
            setIsLoading(false); // Stop loading regardless of success or failure
            document.getElementById("submit-button").disabled = false;
        }

        document.getElementById("submit-button").disabled = false;
    };

    const excelDateToJSDate = (serial) => {
        if (typeof serial !== 'number') return null;

        // Excel epoch: 1900-01-01
        const excelEpoch = moment('1900-01-01');

        // Gün kısmı
        const daysPart = Math.floor(serial);
        // Saat kısmı (0-1 arası decimal)
        const timePart = serial - daysPart;

        // Excel'in leap year hatasını düzelt (1900 yılı leap year değil ama Excel öyle kabul ediyor)
        let targetDate;
        if (serial >= 60) {
            // 1900-03-01'den sonraki tarihler için 1 gün çıkar
            targetDate = excelEpoch.add(daysPart - 2, 'days');
        } else {
            targetDate = excelEpoch.add(daysPart - 1, 'days');
        }

        // Saat bilgisini ekle
        const totalSeconds = Math.round(86400 * timePart);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        targetDate.set({
            hour: hours,
            minute: minutes,
            second: seconds,
            millisecond: 0
        });

        return targetDate.toDate();
    };
    // Excel'i işleyen gelişmiş fonksiyon
    const processExcelWithDateTime = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                try {
                    const data = new Uint8Array(event.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const worksheet = workbook.Sheets[workbook.SheetNames[0]];

                    const rawData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
                    const headers = Object.keys(rawData[0] || {});
                    const dateColumns = detectDateColumns(headers);

                    const processedData = rawData.map(row => {
                        const processedRow = { ...row };

                        dateColumns.forEach(col => {
                            if (processedRow[col] !== null && processedRow[col] !== undefined) {
                                let jsDate = null;

                                if (typeof processedRow[col] === 'number') {
                                    jsDate = excelDateToJSDate(processedRow[col]);
                                } else if (typeof processedRow[col] === 'string') {
                                    // Geliştirilmiş temizleme fonksiyonunu kullan
                                    const cleanedDateString = cleanDateStringAdvanced(processedRow[col]);

                                    const parsedDate = moment(cleanedDateString, [
                                        'DD.MM.YYYY', 'DD.MM.YYYY HH:mm:ss', 'DD.MM.YYYY HH:mm',
                                        'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD',
                                        'DD/MM/YYYY', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm',
                                        'MM/DD/YYYY', 'MM/DD/YYYY HH:mm:ss', 'MM/DD/YYYY HH:mm',
                                        'DD-MM-YYYY', 'DD-MM-YYYY HH:mm:ss', 'DD-MM-YYYY HH:mm',
                                        'MM-DD-YYYY', 'MM-DD-YYYY HH:mm:ss', 'MM-DD-YYYY HH:mm',
                                        'YYYY/MM/DD', 'YYYY/MM/DD HH:mm:ss', 'YYYY/MM/DD HH:mm'
                                    ], true);

                                    if (parsedDate.isValid()) {
                                        jsDate = parsedDate.toDate();
                                    }
                                }

                                if (jsDate) {
                                    // Türkçe format: DD.MM.YYYY HH:mm:ss
                                    const formattedDate = moment(jsDate).format('DD.MM.YYYY HH:mm:ss');
                                    console.log('Excel sayısal tarih formatlandı:', formattedDate);
                                    // Temizleme fonksiyonu ile son kontrol
                                    const cleanedDate = cleanDateStringAdvanced(formattedDate);
                                    console.log('Excel sayısal tarih temizlendi:', cleanedDate);
                                    processedRow[col] = cleanedDate;
                                }
                            }
                        });

                        return processedRow;
                    });

                    resolve({
                        data: processedData,
                        dateColumns: dateColumns
                    });

                } catch (error) {
                    reject(error);
                }
            };

            reader.onerror = reject;
            reader.readAsArrayBuffer(file);
        });
    };    // Tarih kolonlarını tespit eden fonksiyon - 1-1 eşleşme
    const detectDateColumns = (headers) => {
        const dateKeywords = [
            'tarih', 'client invoice date', "Gemi Varış Tarihi"

        ];
        return headers.filter(header =>
            dateKeywords.some(keyword =>
                header.toLowerCase() === keyword.toLowerCase()
            )
        );
    };

    // Tarih string'ini temizleyen yardımcı fonksiyon
    // Tarih string'ini temizleyen yardımcı fonksiyon
    const cleanDateStringAdvanced = (dateString) => {
        if (!dateString || typeof dateString !== 'string') return dateString;

        console.log('Orijinal:', dateString);

        // 1. Fazla boşlukları tek boşlukla değiştir
        let cleaned = dateString.replace(/\s+/g, ' ').trim();

        // 2. Saat formatındaki tüm boşlukları temizle (daha güçlü regex)
        // "HH: MM: SS" -> "HH:MM:SS"
        // "HH: MM" -> "HH:MM"
        // "HH: MM : SS" -> "HH:MM:SS"
        // "HH : MM : SS" -> "HH:MM:SS"
        cleaned = cleaned.replace(/(\d{1,2})\s*:\s*(\d{1,2})(\s*:\s*(\d{1,2}))?/g, (match, hours, minutes, _, seconds) => {
            const paddedHours = hours.padStart(2, '0');
            const paddedMinutes = minutes.padStart(2, '0');
            if (seconds) {
                const paddedSeconds = seconds.padStart(2, '0');
                return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
            }
            return `${paddedHours}:${paddedMinutes}`;
        });

        // 3. Tarih ile saat arasında tek boşluk bırak
        cleaned = cleaned.replace(/(\d{2}\.\d{2}\.\d{4})\s+(\d{2}:\d{2}:\d{2})/g, '$1 $2');
        cleaned = cleaned.replace(/(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2})/g, '$1 $2');

        // 4. Son kontrol: kalan tüm fazla boşlukları temizle
        cleaned = cleaned.replace(/\s+/g, ' ').trim();

        console.log('Temizlenmiş:', cleaned);
        return cleaned;
    };

    // Kullanıcıya gösterilen Excel dosyaları için Türkçe tarih formatı ile işleme
    const processExcelForDisplay = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                try {
                    const data = new Uint8Array(event.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const worksheet = workbook.Sheets[workbook.SheetNames[0]];

                    // Raw data al (sayısal değerler korunur)
                    const rawData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
                    const headers = Object.keys(rawData[0] || {});

                    // Tarih kolonlarını otomatik tespit et
                    const dateColumns = detectDateColumns(headers);

                    // Verileri işle (Türkçe format için)
                    const processedData = rawData.map(row => {
                        const processedRow = { ...row };

                        dateColumns.forEach(col => {
                            if (processedRow[col] && typeof processedRow[col] === 'number') {
                                // Excel tarih numarasını JavaScript Date'e çevir
                                const jsDate = excelDateToJSDate(processedRow[col]);
                                if (jsDate) {
                                    // Türkçe format: DD.MM.YYYY HH:mm:ss
                                    const formattedDate = moment(jsDate).format('DD.MM.YYYY HH:mm:ss');
                                    // Temizleme fonksiyonu ile son kontrol
                                    processedRow[col] = cleanDateStringAdvanced(formattedDate);
                                }
                            } else if (processedRow[col] && typeof processedRow[col] === 'string') {
                                // String tarih formatlarını da kontrol et - temizleme fonksiyonu kullan
                                const cleanedDateString = cleanDateStringAdvanced(processedRow[col]);

                                const parsedDate = moment(cleanedDateString, [
                                    'DD.MM.YYYY', 'DD.MM.YYYY HH:mm:ss',
                                    'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD',
                                    'DD/MM/YYYY', 'DD/MM/YYYY HH:mm:ss',
                                    'MM/DD/YYYY', 'MM/DD/YYYY HH:mm:ss',
                                    'DD-MM-YYYY', 'DD-MM-YYYY HH:mm:ss',
                                    'MM-DD-YYYY', 'MM-DD-YYYY HH:mm:ss',
                                    'YYYY/MM/DD', 'YYYY/MM/DD HH:mm:ss'
                                ], true);
                                if (parsedDate.isValid()) {
                                    // Türkçe format: DD.MM.YYYY HH:mm:ss
                                    const formattedDate = parsedDate.format('DD.MM.YYYY HH:mm:ss');
                                    // Temizleme fonksiyonu ile son kontrol
                                    processedRow[col] = cleanDateStringAdvanced(formattedDate);
                                }
                            }
                        });

                        return processedRow;
                    });

                    resolve({
                        data: processedData,
                        dateColumns: dateColumns
                    });

                } catch (error) {
                    reject(error);
                }
            };

            reader.onerror = reject;
            reader.readAsArrayBuffer(file);
        });
    };

    // Hatalı/uyarılı şaseler için gelişmiş Excel indirme fonksiyonu
    const downloadErrorWarningExcel = async (data, title) => {
        if (!file || !data || data.length === 0) {
            notifyError(t("İndirilecek veri bulunamadı."));
            return;
        }

        try {
            // Yüklenen Excel dosyasını oku (kullanıcıya gösterilen format ile)
            const result = await processExcelForDisplay(file);
            const originalData = result.data;

            // Hata/uyarı verilerini şase numarasına göre grupla ve tipini belirle
            const errorWarningMap = {};
            const rowTypeMap = {}; // Hata mı uyarı mı olduğunu takip etmek için

            data.forEach(item => {
                if (!errorWarningMap[item.chassis_no]) {
                    errorWarningMap[item.chassis_no] = [];
                }
                errorWarningMap[item.chassis_no].push(item.message);

                // Eğer action "warning" ise uyarı, değilse hata olarak işaretle
                if (item.action === "warning") {
                    rowTypeMap[item.chassis_no] = "warning";
                } else {
                    rowTypeMap[item.chassis_no] = "error";
                }
            });

            // Orijinal veriyi hata/uyarı mesajları ile birleştir
            const combinedData = originalData.map(row => {
                const chassisNo = row.sase || row.chassis_no;
                const errorMessages = errorWarningMap[chassisNo] || [];

                // Önce orijinal veriyi kopyala, sonra Hata/Uyarı Mesajı sütununu G kolonuna ekle
                const rowData = { ...row };
                delete rowData['Hata/Uyarı Mesajı']; // Eğer varsa önce sil

                // G kolonunda sabitlemek için özel sıralama
                const orderedRowData = {};
                const originalKeys = Object.keys(rowData);

                // İlk 6 kolonu (A-F) ekle
                for (let i = 0; i < Math.min(6, originalKeys.length); i++) {
                    orderedRowData[originalKeys[i]] = rowData[originalKeys[i]];
                }

                // G kolonuna Hata/Uyarı Mesajı ekle
                orderedRowData['Hata/Uyarı Mesajı'] = errorMessages.join(' | ');

                // Kalan kolonları ekle (H ve sonrası)
                for (let i = 6; i < originalKeys.length; i++) {
                    orderedRowData[originalKeys[i]] = rowData[originalKeys[i]];
                }

                return orderedRowData;
            }).filter(row => {
                // Sadece hata/uyarı olan şaseleri filtrele
                const chassisNo = row.sase || row.chassis_no;
                return errorWarningMap[chassisNo] && errorWarningMap[chassisNo].length > 0;
            });

            if (combinedData.length === 0) {
                notifyError(t("İndirilecek veri bulunamadı."));
                return;
            }

            // Excel oluştur
            const newWorksheet = XLSX.utils.json_to_sheet(combinedData);
            const newWorkbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, title);

            // Sütun genişliklerini ayarla
            const maxWidth = 25;
            const columnWidths = Object.keys(combinedData[0] || {}).map(() => ({ wch: maxWidth }));
            newWorksheet['!cols'] = columnWidths;

            // Hata/Uyarı Mesajı sütununa renkli arkaplan ekle (G kolonu - index 6)
            const messageColumnIndex = 6; // G kolonu sabit
            const messageColumnLetter = 'G'; // G kolonu sabit

            // Header'a renk ekle (1. satır)
            const headerCellAddress = `${messageColumnLetter}1`;
            if (newWorksheet[headerCellAddress]) {
                newWorksheet[headerCellAddress].s = {
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: title.includes("Hatalı") ? "FFCCCC" : "FFE6CC" } // Daha koyu header rengi
                    },
                    font: {
                        color: { rgb: title.includes("Hatalı") ? "990000" : "CC6600" }, // Koyu renk yazı
                        bold: true
                    }
                };
            }

            // Her satır için renkli arkaplan ekle
            combinedData.forEach((row, rowIndex) => {
                const chassisNo = row.sase || row.chassis_no;
                const rowType = rowTypeMap[chassisNo] || "error"; // Varsayılan olarak hata
                const rowNumber = rowIndex + 2; // +2 çünkü header 1. satır ve 0-based index

                // G kolonundaki mesaj hücresi için renk
                const messageCellAddress = `${messageColumnLetter}${rowNumber}`;
                if (!newWorksheet[messageCellAddress]) {
                    newWorksheet[messageCellAddress] = { v: '' };
                }

                // Mesaj hücresi için renkli arkaplan
                newWorksheet[messageCellAddress].s = {
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: rowType === "warning" ? "FFF2E6" : "FFE6E6" } // Sarı veya kırmızı arkaplan
                    },
                    font: {
                        color: { rgb: rowType === "warning" ? "CC6600" : "CC0000" }, // Koyu turuncu veya koyu kırmızı yazı
                        bold: true
                    },
                    alignment: {
                        horizontal: "left",
                        vertical: "center"
                    }
                };

                // Tüm satır için arkaplan rengi uygula
                const allColumns = Object.keys(combinedData[0] || {});
                allColumns.forEach((_, colIndex) => {
                    const columnLetter = XLSX.utils.encode_col(colIndex);
                    const cellAddress = `${columnLetter}${rowNumber}`;

                    // Eğer hücre yoksa oluştur
                    if (!newWorksheet[cellAddress]) {
                        newWorksheet[cellAddress] = { v: '' };
                    }

                    // Satır arkaplan rengi uygula
                    newWorksheet[cellAddress].s = {
                        fill: {
                            patternType: "solid",
                            fgColor: { rgb: rowType === "warning" ? "FFFFE6" : "FFE6E6" } // Açık sarı veya açık kırmızı
                        },
                        alignment: {
                            horizontal: "left",
                            vertical: "center"
                        }
                    };
                });

                console.log(`Satır ${rowNumber} için ${rowType} rengi uygulandı: ${chassisNo}`);
            });

            console.log(`Hata/Uyarı Mesajı sütunu ${messageColumnLetter} kolonuna renkli arkaplan eklendi`);
            console.log('Toplam satır sayısı:', combinedData.length);
            console.log('Row type map:', rowTypeMap);

            // Dosyayı indir
            const fileName = `${title}_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
            XLSX.writeFile(newWorkbook, fileName);

            notifySuccess(t(`${title} başarıyla indirildi.`));

        } catch (error) {
            console.error('Excel oluşturma hatası:', error);
            notifyError(t("Excel dosyası oluşturulurken bir hata oluştu."));
        }
    };





    const clearFile = () => {
        setFile(null);
        setError('');
        setErrorArray([]);
        setSuccessCount(0);
        setWarningsArray([]);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        const fileInput = document.getElementById('excelUpload');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const processWarnings = (warningsArray) => {
        const groupedWarnings = warningsArray.reduce((acc, curr) => {
            if (!acc[curr.chassis_no]) {
                acc[curr.chassis_no] = [];
            }
            acc[curr.chassis_no].push(curr.message);
            return acc;
        }, {});

        return Object.entries(groupedWarnings).map(([chassis_no, messages]) => ({
            chassis_no,
            message: messages.join('<br/>')
        }));
    };

    const WarningsCell = ({ value }) => {
        return <div dangerouslySetInnerHTML={{ __html: t(value) }} />;
    };

    const renderResultGrid = (data, ref, title, color, icon) => {

        if (!data || data?.length === 0) return null;
        if (data?.[0]?.message?.info) return null;
        if (data?.length > 0) {
            return (
                <div className="space-y-4 mt-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                            <span style={{ fontSize: "18px" }}>{icon}</span>
                            <span className="font-bold" style={{ color, fontSize: "16px" }}>{t(title)} ({data.length} adet):</span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center"
                            }}
                        >
                            {process_type === "BLOCKING_SHIPPING" && title === "Şase Uyarı Mesajları" && (
                                <Link
                                    target="_blank"
                                    style={{
                                        height: "38px",
                                        margin: "0px"
                                    }}
                                    to="/tanimlamalar/sevkiyat-yerleri"
                                    className="btn btn-info mr-1"
                                >
                                    {t("Sevkiyat Yeri Tanımlama")}
                                </Link>
                            )}
                            <Button
                                className="btn btn-success"
                                style={{ height: "38px" }}
                                onClick={(e) => {
                                    // Yeni gelişmiş Excel indirme fonksiyonunu kullan
                                    downloadErrorWarningExcel(data, title);
                                }}
                            >
                                <i className="fa fa-file-excel-o"></i> {t("Excel İndir")}
                            </Button>
                        </div>
                    </div>
                    <DataGrid
                        ref={ref}
                        dataSource={data}
                        showColumnHeaders={false}
                        filterRow={{ visible: true }}
                        showColumnLines={true}
                        showRowLines={true}
                        showBorders={true}
                        columnAutoWidth={true}
                        headerFilter={{ visible: false }}
                        height={Math.min(data.length * 40 + 50, 300)} // Maksimum 300px yükseklik
                    >
                        <Column
                            dataField="chassis_no"
                            caption={t("Şase No")}
                            alignment="center"
                            selectedFilterOperation="contains"
                            width={180}
                            cellRender={({ value }) => (
                                <div style={{
                                    fontWeight: '600',
                                    color: '#2c3e50',
                                    fontSize: '13px'
                                }}>
                                    {value}
                                </div>
                            )}
                        />
                        <Column
                            dataField="message"
                            caption={t("Mesaj")}
                            selectedFilterOperation="contains"
                            cellRender={({ value, data }) => {
                                let message = value || "";

                                if (message.includes("invalid client code")) {
                                    const codeMatch = message.match(/\((\d+)\)/);
                                    const nameMatch = message.match(/name \((\w+)\)/);
                                    const code = codeMatch ? codeMatch[1] : "";
                                    const name = nameMatch ? nameMatch[1] : "";
                                    return (
                                        <div style={{
                                            color: '#e74c3c',
                                            fontWeight: '500',
                                            fontSize: '12px',
                                            padding: '0px',
                                            //  backgroundColor: '#fdf2f2',
                                            //  borderRadius: '3px'
                                        }}>
                                            {message?.replace("dosya işlenirken hata:", "")}
                                        </div>
                                    );
                                }

                                message = message.split(":");
                                message = message.map((m, index) => {
                                    if (index === 0) {
                                        return t(m.trim());
                                    }
                                    return t(m.trim());
                                });

                                const displayMessage = message.join(": ");

                                // Mesaj tipine göre minimal stil uygula
                                let messageStyle = {
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    padding: '4px 8px',
                                    borderRadius: '3px'
                                };

                                if (data.action === "warning") {
                                    messageStyle = {
                                        ...messageStyle,
                                        color: '#f39c12',
                                        backgroundColor: '#fef9e7'
                                    };
                                } else {
                                    messageStyle = {
                                        ...messageStyle,
                                        color: '#e74c3c',
                                        backgroundColor: '#fdf2f2'
                                    };
                                }

                                return (
                                    <div style={messageStyle}>
                                        {displayMessage}
                                    </div>
                                );
                            }}
                        />
                    </DataGrid>
                </div>
            );
        }
    };
    return (
        <>
            <Breadcrumb current={t(Title)} depo={depo} />
            <Card className="mt-1">
                <CardBody>
                    <Row>
                        <Col md="6" className='d-flex align-items-center' style={{ gap: "15px" }}>
                            {process_type === "VEHICLE" &&
                                <RadioGroup
                                    id='isMilli'
                                    items={[{ text: "GEMİ", value: false }, { text: "FABRİKA", value: true },
                                    { text: "BAYİ", value: true },
                                    { text: "DEPO", value: true }
                                    ]}
                                    defaultValue={"GEMİ"}
                                    layout="horizontal"
                                    displayExpr={"text"}
                                    valueExpr={"text"}
                                    itemRender={({ text }) => t(text)}
                                />
                            }
                        </Col>
                    </Row>

                    <Row className='mb-4'>
                        <Col md="6">
                        </Col>
                        <Col md="6" style={{ textAlign: "right" }}>
                            <b>
                                {t("Yüklemek İstediğiniz Excel Dosyasını seçiniz. Excel Şablonunu")}
                                <span style={{
                                    color: "blue",
                                    cursor: "pointer"
                                }} onClick={() => downloadSampleExcel(
                                    requiredColumnsSase,
                                    process_type,
                                    Title
                                )}> {t("buradan")} </span>
                                {t("indirebilirsiniz")}.
                            </b>
                        </Col>
                    </Row>

                    <FormGroup style={{ display: "flex" }}>
                        <Label for="excelUpload" className="font-weight-bold">
                            {t("Excel Dosyası Yükle")}
                        </Label>
                        <InputGroup>
                            <Input
                                id="excelUpload"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileChange}
                                style={{ display: 'none', height: "100%" }}
                                ref={fileInputRef}
                            />
                            <Input
                                type="text"
                                placeholder="Choose file..."
                                value={file ? file.name : ''}
                                readOnly
                                style={{ height: "100%" }}
                            />
                            <InputGroupAddon addonType="append" onClick={() => clearFile()}>
                                <InputGroupText>
                                    <Label for="excelUpload" style={{ cursor: 'pointer', marginBottom: 0 }}>
                                        {t("Seç")}
                                    </Label>
                                </InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                    </FormGroup>

                    <br />
                    {error && (
                        <Row>
                            <Col md="12">
                                <p style={{ fontWeight: "bold", fontSize: "15px", color: "black" }}
                                    dangerouslySetInnerHTML={{ __html: error }} />
                            </Col>
                        </Row>
                    )}
                    <br />

                    <Row>
                        <Col md="12" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}>
                            <div style={{ display: "flex", gap: "10px" }}>
                                <Button
                                    color='danger'
                                    disabled={file === null || isLoading}
                                    onClick={clearFile}
                                >
                                    {t("Temizle")}
                                </Button>

                            </div>
                            {isLoading && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    color: '#007bff'
                                }}>
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span style={{ fontWeight: 'bold' }}>{t("Yükleniyor. Lütfen sayfan çıkmadan bekleyiniz...")}</span>
                                </div>
                            )}
                            {
                                hasRole(role_name) &&
                                <Button
                                    color="primary"
                                    id='submit-button'
                                    disabled={file === null || isLoading}
                                    onClick={handleSubmit}
                                    style={{ width: "max-content" }}
                                >
                                    {t("Kaydet")}
                                </Button>}
                        </Col>
                    </Row>

                    <hr />
                    <Row>
                        <Col md="12" className='mb-2'>
                            <span style={{
                                color: "blue",
                                fontWeight: "bold"
                            }}>
                                {exampleData ?
                                    t("Excel Dosyasında bulunması gereken kolonlar ve örnek veri")
                                    :
                                    t("Excel Dosyasında bulunması gereken kolonlar")}:
                            </span>
                        </Col>
                        <Col md="12">
                            <table className="table table-bordered">
                                <thead>
                                    <tr style={{
                                        backgroundColor: "#e2e2e2"
                                    }}>
                                        {requiredColumnsSase.map((column, index) => (
                                            <th
                                                style={{ border: "1px solid rgb(208 208 208)" }}
                                                key={index}
                                            >
                                                {column}
                                                {column === "sase" &&
                                                    <span style={{
                                                        color: "red",
                                                        fontWeight: "900",
                                                        fontSize: "17px"
                                                    }}>*</span>
                                                }
                                            </th>
                                        ))}
                                    </tr>
                                    {
                                        exampleData &&
                                        exampleData.map((data, index) => (
                                            <tr key={index}>
                                                {requiredColumnsSase.map((column, index) => (
                                                    <td style={{
                                                        padding: "5px",
                                                    }}
                                                        key={index}>{data[column]}</td>
                                                ))}
                                            </tr>
                                        ))
                                    }
                                    {
                                        exampleData === undefined &&
                                        <tr>
                                            {
                                                requiredColumnsSase.map((column, index) => (
                                                    <td key={index}>
                                                        <i>{column === "GEMİ Varış Tarihi" ? "Date" : "Text"}</i>
                                                    </td>
                                                ))
                                            }
                                        </tr>
                                        // requiredColumnsSase.map((column, index) => (
                                        //     <td key={index}>
                                        //         <i>{column === "GEMİ Varış Tarihi" ? "Date" : "Text"}</i>
                                        //     </td>
                                        // ))}
                                    }
                                </thead>
                            </table>
                        </Col>
                    </Row>

                    <hr />

                    {/* Başarılı Kayıt Sayısı */}
                    {successCount > 0 && (
                        <div className="d-flex align-items-center mb-3" style={{ gap: "8px" }}>
                            <span style={{ fontSize: "18px" }}>✅</span>
                            <span style={{
                                color: "#27ae60",
                                fontWeight: "bold",
                                fontSize: "16px"
                            }}>
                                {successCount} adet kayıt başarıyla işlendi
                            </span>
                        </div>
                    )}

                    {/* Error Grid */}
                    {renderResultGrid(errorArray, errorGridRef, "Hatalı Şase Listesi", "#e74c3c", "❌")}

                    {/* Warning Grid */}
                    {/* {process_type === "SHIP_UNLOAD" &&
                        renderResultGrid(warningsArray, warningGridRef, "Uyarılı Şase Listesi", "orange")} */}

                    {/* Warnings Grid */}
                    {renderResultGrid(warningsArray, warningsGridRef, "Şase Uyarı Mesajları", "#f39c12", "⚠️")}

                </CardBody>
            </Card>
        </>
    );
};

export default ExcelUpload;

export const downloadSampleExcel = (requiredColumnsSase, process_type, Title) => {
    let templateColumns = [...requiredColumnsSase];
    if (process_type === "VEHICLE") {
        templateColumns = requiredColumnsSase;
    }

    const worksheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(worksheet, [templateColumns]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sayfa1');
    XLSX.writeFile(workbook, `${Title}.xlsx`);
};